import React from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";

import SkillItem from "components/SkillItem";
import SectionHeader from "components/SectionHeader";
import PageSection from "components/PageSection";

const Skill = ({ className, frontmatter }) => {
  if (!frontmatter) {
    return null;
  }

  const {
    anchor,
    header: rootHeader,
    subheader: rootSubHeader,
    skills,
    wordingMainSkill,
    wordingOtherSkill,
  } = frontmatter;
  return (
    <PageSection className={className} id={anchor}>
      <Row>
        <SectionHeader header={rootHeader} subheader={rootSubHeader} />
      </Row>
      <Row className="text-center">
        {skills.map((service) => (
          <Col md={6} key={service.header}>
            <SkillItem {...service} wording={{ wordingOtherSkill, wordingMainSkill }} />
          </Col>
        ))}
      </Row>
    </PageSection>
  );
};

Skill.propTypes = {
  className: PropTypes.string,
  frontmatter: PropTypes.object,
};

Skill.defaultProps = {
  className: null,
  frontmatter: null,
};

export default Skill;
